export default __webpack_public_path__ + "static/media/dark-circled-cross.4704e9ff.svg";